import * as React from 'react';

const useGlobalClassName = (currentTheme, classNameMap) => {
    React.useLayoutEffect(() => {
        const currentClassName = classNameMap[currentTheme];
        if (!document.documentElement.matches(`.${currentClassName.join('.')}`)) {
            const allThemeClasses = Object.values(classNameMap).reduce((prevValue, currentValue) => {
                return [...prevValue, ...currentValue];
            }, []);
            document.documentElement.classList.remove(...allThemeClasses);
            document.documentElement.classList.add(...currentClassName);
        }
    }, [currentTheme, classNameMap]);
};

export { useGlobalClassName };
